module.exports = __webpack_public_path__ + "img/kommune-1867.33758776.svg";